import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SharedUtilitiesModule } from '../../../../utilities/shared-utilities.module';
import { AppletAuditTrailContainerComponent } from './applet-audit-trail-container.component';
import { AppletAuditTrailListingComponent } from './applet-audit-trail-listing/applet-audit-trail-listing.component';
import { AppletAuditTrailEditComponent } from './applet-audit-trail/applet-audit-trail-edit.component';
import { StoreModule } from '@ngrx/store';
import { auditTrailFeatureKey } from '../../settings-controller/applet-audit-trail/selectors/applet-audit-trail.selector';
import { auditTrailReducers } from '../../settings-controller/applet-audit-trail/reducers/root';
import { ModulesEscapeHtmlPipe } from './applet-audit-trail/escape-html.pipe';

export const auditAgGridModule = AgGridModule.withComponents([]);
export const auditStoreModule = StoreModule.forFeature(auditTrailFeatureKey, auditTrailReducers.auditTrail);

@NgModule({
  declarations: [
    AppletAuditTrailContainerComponent,
    AppletAuditTrailListingComponent,
    AppletAuditTrailEditComponent,
    ModulesEscapeHtmlPipe
  ],
  imports: [
    CommonModule,
    SharedUtilitiesModule,
    FormsModule,
    ReactiveFormsModule,
    auditAgGridModule,
    FlexLayoutModule,
    NgxMatSelectSearchModule,
    auditStoreModule
  ]
})
export class AppletAuditTrailModule { }
